export const speakerBgColors = [
  'bg-violet-600',
  'bg-emerald-600',
  'bg-sky-600',
  'bg-rose-600',
  'bg-orange-600',
  'bg-fuchsia-600',
  'bg-yellow-600',
  'bg-cyan-600'
];
export const speakerLightBgColors = [
  'bg-violet-100',
  'bg-emerald-100',
  'bg-sky-100',
  'bg-rose-100',
  'bg-orange-100',
  'bg-fuchsia-100',
  'bg-yellow-100',
  'bg-cyan-100'
];

export const speakerTextColors = [
  'text-violet-600',
  'text-emerald-600',
  'text-sky-600',
  'text-rose-600',
  'text-orange-600',
  'text-fuchsia-600',
  'text-yellow-600',
  'text-cyan-600'
];

export const speakerHoverBgColors = [
  'hover:bg-violet-300',
  'hover:bg-emerald-300',
  'hover:bg-sky-300',
  'hover:bg-rose-300',
  'hover:bg-orange-300',
  'hover:bg-fuchsia-300',
  'hover:bg-yellow-300',
  'hover:bg-cyan-300'
];

export const screenShareBarsColors = {
  bgColor: 'bg-slate-600',
  lightBgColor: 'bg-slate-100',
  textColor: 'text-slate-600',
  hoverBgColor: 'hover:bg-slate-300'
};

export const sharedVideoBarsColors = {
  bgColor: 'bg-blue-900',
  lightBgColor: 'bg-blue-100',
  textColor: 'text-blue-900',
  hoverBgColor: 'hover:bg-blue-800'
};
